import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

interface OptionButton {
  /**
   * text to be shown in the button
   */
  text: string;
  /**
   * value to be returned after clicking the option to the callback
   */
  returnValue: string;
}

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss']
})
export class ExportDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { heading: string, options: OptionButton[] }) {
  }

  ngOnInit(): void {
  }

}
